import React, { useState, useRef } from 'react';
import { Growl } from 'primereact/growl';

import { Lista } from '../configuracion/Lista';
import { Formulario } from './Formulario';
import { TablaConsultaSolicitudesSat } from '../tablas/TablaConsultaSolicitudesSat';
import servicioObjetos from '../../../servicio/ServicioObjetos';
import servicioHttp from '../../../servicio/ServicioHttp';

const PAGINACION_INICIAL = {
    registrosPorPagina: 50,
    registrosTotales: 0,
    join: {
        'ttSolicitudDescargaCfdi': 'alias_ttSolicitudDescargaCfdi',
        'alias_ttSolicitudDescargaCfdi.tcFiel': 'alias_tcFiel',
    },
    restriccionesDinamicas: [
        {
            tipoRestriccion: "eq",
            nombrePropiedad: "tipoSolicitud",
            valorPropiedad: "Metadata"
        },
        {
            tipoRestriccion: "isNull",
            nombrePropiedad: "tipoComprobante",            
        }
    ],
    datos: [],
    ordenamientos: [
        {
            tipo: "asc",
            nombrePropiedad: "fechaInicial"
        }
    ]
}
export const DescargaCfdiSua = (props) => {

    const urlDescarga = "subsolicitud_descargacfdi/sua/descargar.json";
    const [empresa, setEmpresa] = useState(null);
    const [tcFielDb, setTcFielDb] = useState(null);
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    let growl = useRef(null);

    const buscarSubSolicitudesSat = (laFiel) => {
        if (!servicioObjetos.esObjetoVacio(laFiel)) {
            let laPaginacion = { ...PAGINACION_INICIAL };
            laPaginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcFiel.id",
                valorPropiedad: laFiel.id
            });
            servicioHttp.consumirPostHttp('subsolicitud_descargacfdi/consultar.json', laPaginacion).then(response => {
                setPaginacion(response.data.objeto);
            }).catch(error => {

            });
        }
    }

    const onSeleccionEmpresa = (empresaSeleccionada) => {
        if (servicioObjetos.esObjetoVacio(empresaSeleccionada)) {
            empresaSeleccionada = {};
            setEmpresa(null);
            return;
        }
        setEmpresa(empresaSeleccionada);
        let idEmpresa = empresaSeleccionada.value;
        servicioHttp.consumirPostHttp('fiel/buscar_por_empresa.json', { id: idEmpresa }).then(response => {
            let laFiel = response.data.objeto;
            setTcFielDb(laFiel);
            buscarSubSolicitudesSat(laFiel);
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
        });
    }

    const onFormularioOk = (objetoFormulario) => {
        let ultimaHoraMes = new Date(objetoFormulario.getFullYear(), objetoFormulario.getMonth() + 1, 0);
        ultimaHoraMes.setHours(23, 59, 59);
        if (servicioObjetos.esObjetoVacio(empresa)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'Debes de elegir una empresa', life: 10000 });
            return;
        }
        if (servicioObjetos.esObjetoVacio(tcFielDb)) {
            growl.current.clear();
            growl.current.show({ severity: 'error', summary: 'Error', detail: 'El rfc seleccionado no cuenta con información de E.firma debes de ingresar E.firma en la sección configuración del menu Descarga Cfdi', life: 10000 });
            return;
        }

        let solicitudDescarga = {};
        solicitudDescarga.tcFiel = {
            id: tcFielDb.id
        }
        solicitudDescarga.fechaInicial = objetoFormulario.getTime();
        solicitudDescarga.fechaFinal = ultimaHoraMes.getTime();
        servicioHttp.consumirPostHttp('solicitud_descargacfdi/sua/guardar.json', solicitudDescarga).then(response => {
            let data = response.data;
            buscarSubSolicitudesSat(tcFielDb);
            growl.current.show({ severity: data.error ? 'error' : 'success', summary: data.error ? 'Error' : 'Éxito', detail: data.error ? "Existe un error de conexión con el servidor, contacte a un administrador" : 'Solicitud agregada con éxito', life: 10000 });
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error de conexión con el servidor, contacte a un administrador", life: 10000 });
        });
    }

    return (
        <div>
            <Growl ref={growl} />
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <h1>Descarga de Cfdi Sua</h1>
                        <p>En este módulo usted puede realizar la solicitud manual para poder descargar CFDI del SUA</p>
                    </div>
                </div>
            </div>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <Lista onSeleccionEmpresa={onSeleccionEmpresa} />
                    </div>
                </div>
            </div>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <Formulario onFormularioOk={onFormularioOk} growl={growl} />
                    </div>
                </div>
            </div>
            <div className="card">
                <TablaConsultaSolicitudesSat paginacion={paginacion} urlDescarga={urlDescarga} growl={growl}/>
            </div>
        </div>
    );
}